import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { AlertCircle, Trash2 } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { ModalSuccess } from './ModalSuccess';
import { TrainingCourse } from '../../types/trainingCourse';
interface CourseDeleteModalProps {
  course: TrainingCourse | null;
  trainedCount: number;
  onClose: () => void;
  onConfirm: (course: TrainingCourse) => void;
}
export function CourseDeleteModal({
  course,
  trainedCount,
  onClose,
  onConfirm
}: CourseDeleteModalProps) {
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (course) setDone(false);
  }, [course]);
  const handleConfirm = () => {
    if (!course) return;
    setDone(true);
    setTimeout(() => {
      onConfirm(course);
      onClose();
    }, 1200);
  };
  return <Modal isOpen={Boolean(course)} onClose={onClose} title="Conferma eliminazione" size="sm" data-id="element-1218" data-mp="326chqel1lg0t">
      <AnimatePresence mode="wait" data-id="element-1219" data-mp="2cbj7o1jckzk9">
        {done ? <ModalSuccess title="Eliminato con successo" data-id="element-1220" data-mp="2carjhbs2y440" /> : <motion.div key="confirm" exit={{
        opacity: 0
      }} className="space-y-6" data-id="element-1221" data-mp="2h8t5o5ksyjjp">
            <div className="bg-red-50 p-4 rounded-lg border border-red-100 flex gap-3" data-id="element-1222" data-mp="2m8xpa4h0bue5">
              <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0" data-id="element-1223" data-mp="2qbar4hsmv85n" />
              <div data-id="element-1224" data-mp="1tkib1k5p9g3v">
                <p className="text-sm text-red-700 font-medium" data-id="element-1225" data-mp="1tl1td1z9i6if">
                  Attenzione: questa azione è irreversibile.
                </p>
                <p className="text-sm text-red-600 mt-1" data-id="element-1226" data-mp="1yjuwc0gxaf4c">
                  Il corso <strong data-id="element-1227" data-mp="22kyeitmg0n8q">{course?.name || course?.courseCode}</strong>{' '}
                  verrà eliminato definitivamente.
                </p>
                {trainedCount > 0 && <p className="text-sm text-red-600 mt-1" data-id="element-1228" data-mp="1auk4x9lgpx2v">
                    {trainedCount === 1 ? '1 corso trainato perderà' : `${trainedCount} corsi trainati perderanno`}{' '}
                    il collegamento al corso trainante.
                  </p>}
              </div>
            </div>
            <div className="flex justify-end gap-3 pt-2" data-id="element-1229" data-mp="2d5c81rmypdug">
              <Button variant="flat" color="default" onClick={onClose} data-id="element-1230" data-mp="2rvb67ueiop9x">
                Annulla
              </Button>
              <Button color="danger" onClick={handleConfirm} startContent={<Trash2 className="h-4 w-4" data-id="element-1232" data-mp="1z7xh2ih28y0d" />} data-id="element-1231" data-mp="2mxrq0oy9e2fc">
                Elimina
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </Modal>;
}